import {
  PublicClientApplication,
  LogLevel,
  EventType,
} from '@azure/msal-browser';
import { environments, getEnvironment } from '../helpers';

// App Registration ID
var env = getEnvironment();
const devId = '32ba741e-55ff-42a5-9b89-65c6c467c050';
const stageId = '8beaa7ad-3d54-419a-ab70-e79deefa4dd0';
const prodId = '1f9cb53e-37eb-4f1c-808f-cf3295c1cfa9';
let appId = devId;
switch (env) {
  case environments.LocalDev:
  case environments.Development:
    appId = devId;
    break;
  case environments.Staging:
    appId = stageId;
    break;
  case environments.Production:
    appId = prodId;
    break;
  default:
    break;
}
const authLogging = process.env.REACT_APP_AUTH_LOGGING;
export const msalConfig = {
  auth: {
    clientId: appId,
    authority: 'https://login.microsoftonline.com/organizations/',
    redirectUri: window.location.protocol + '//' + window.location.host,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || !authLogging) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const scopedAuthRequest = {
  scopes: [],
};
